module.exports = __webpack_public_path__ + "img/drag_group_color_remove.64fa168b.png";